import { render, staticRenderFns } from "./popCategoryAdd.vue?vue&type=template&id=63857848&scoped=true&"
import script from "./popCategoryAdd.vue?vue&type=script&lang=js&"
export * from "./popCategoryAdd.vue?vue&type=script&lang=js&"
import style0 from "./popCategoryAdd.vue?vue&type=style&index=0&id=63857848&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63857848",
  null
  
)

export default component.exports